
import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const FloatingActionButton: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleButtonClick = () => {
    setIsExpanded(false);
  };

  return (
    <div 
      className="floating-action-button fixed z-[9999]"
      style={{
        position: 'fixed !important' as any,
        zIndex: 9999,
        right: '16px !important',
        bottom: 'calc(max(env(safe-area-inset-bottom, 16px), 16px) + 80px) !important',
        transform: 'translateZ(0)',
        WebkitTransform: 'translateZ(0)',
        willChange: 'transform',
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
        display: 'block',
        visibility: 'visible',
        opacity: 1,
        pointerEvents: 'auto',
        isolation: 'isolate',
        contain: 'layout style paint'
      }}
    >
      <div className="relative">
        {/* Options */}
        <div
          className={`absolute bottom-full right-0 mb-2 flex flex-col items-end space-y-2 transition-all duration-200 ${
            isExpanded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2 pointer-events-none"
          }`}
        >
          <Link to="/events/new" onClick={handleButtonClick}>
            <Button
              variant="blue"
              className="mb-2"
            >
              New Event
            </Button>
          </Link>

          <Link to="/animals/new" onClick={handleButtonClick}>
            <Button
              variant="blue"
            >
              New Animal
            </Button>
          </Link>
        </div>

        {/* Main Button */}
        <button
          onClick={toggleExpanded}
          className="h-14 w-14 bg-[hsl(215,95%,32%)] hover:bg-[hsl(215,95%,32%)]/90 shadow-lg text-white rounded-full aspect-square flex items-center justify-center p-0 mb-2"
        >
          {isExpanded ? <X className="h-6 w-6" /> : <Plus className="h-6 w-6" />}
        </button>
      </div>
    </div>
  );
};

export default FloatingActionButton;
